import SvgArrowDown from '@sats-group/icons/24/arrow-down';
import Collapse from '@sats-group/ui-lib/react/collapse/collapse';
import useToggle from '@sats-group/ui-lib/react/hooks/use-toggle';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import type { CollapsibleList as Props } from './collapsible-list.types';

const CollapsibleList: React.FunctionComponent<Props> = ({
  collapsible,
  details,
  info,
  title,
}) => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  return (
    <div className="collapsible-list">
      <button
        aria-controls={collapsible.id}
        aria-expanded={isOpen}
        aria-label={isOpen ? collapsible.close : collapsible.open}
        className="collapsible-list__trigger"
        onClick={toggleIsOpen}
      >
        <div className="collapsible-list__title">
          <Text size={Text.sizes.small} theme={Text.themes.emphasis}>
            {title}
          </Text>
        </div>
        <Text size={Text.sizes.small}>{info}</Text>
        <div
          className={cn('collapsible-list__flourish', {
            'collapsible-list__flourish--flipped': isOpen,
          })}
        >
          <SvgArrowDown />
        </div>
      </button>
      <Collapse componentProps={{ id: collapsible.id }} isOpen={isOpen}>
        <div className="collapsible-list__body">
          {details.map(detail => (
            <React.Fragment key={detail.id}>
              <div className="collapsible-list__muted">
                <Text>{detail.id}</Text>
              </div>
              <Text>{detail.key}</Text>
              <Text>{detail.value}</Text>
            </React.Fragment>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsibleList;
